import { Injectable } from "@angular/core";
import { ContactInformation } from "@app/models/ContactInformation";
import { PMC } from "@app/models/PMC";
import { HOA } from "@app/models/HOA";
import { Products } from "@app/models/Products";
import { CouponData } from "@app/models/CouponData";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class ContactApi extends HOAApiBase {

    constructor() {
        super('ContactApi');
    }

    /**
     * Retrieve contact information
     * Retrieve a list of contact points for the application
     */
    public contactInformationGet(): Observable<ContactInformation[]> {
        return this.http.get<ContactInformation[]>(this.createUrl("hoa-gateway", "/contactInformation"))
    }

    /**
     * Retrieve pmc organization details
     */
    pmcOrganizationDetailsGET(anonymous: boolean, pmcCouponId: string): Observable<PMC> {
        this.check({ anonymous }, 'is boolean', a => typeof a === 'boolean')
        this.check({ pmcCouponId }, 'is non-empty string', a => typeof a === 'string' && a.length > 0)

        // TODO: Have to circle back and try to figure out Caching for this call
        return this.http.get<PMC>(this.createUrl(anonymous ? 'HOAPass' : 'hoa-gateway', '/organization/pmc',),
            { params: { 'pmcCouponId': pmcCouponId } })
    }

    /**
     * Retrieve hoa organization details
     */
    public hoaOrganizationDetailsGET(anonymous: boolean, pmcCouponId: string, hoaCouponId: string): Observable<HOA> {
        this.check({ anonymous }, 'is boolean', a => typeof a === 'boolean')
        this.check({ pmcCouponId, hoaCouponId }, 'non-empty string', a => typeof a === 'string' && a.length > 0)

        if (anonymous) {
            return this.http.get<HOA>(this.createUrl("HOAPass", "/organization/hoa"), {
                params: {
                    'pmcCouponId': pmcCouponId,
                    // notice the spelling difference "hoaCouponId"
                    'hoaCouponId': hoaCouponId,
                },
            })
        } else {
            return this.http.get<HOA>(this.createUrl("hoa-gateway", "/organization/hoa"), {
                params: {
                    'pmcCouponId': pmcCouponId,
                    // notice the spelling difference "hoaCoupondId"
                    // https://bitbucket.mutualofomaha.com/projects/PAY/repos/hoa-gateway/browse/src/main/java/com/mutualofomaha/hoa/gateway/api/OrganizationApiController.java?until=937b8cfdb611cc9c2f0a8eb0e992bdbcf8f86a25&untilPath=src%2Fmain%2Fjava%2Fcom%2Fmutualofomaha%2Fhoa%2Fgateway%2Fapi%2FOrganizationApiController.java#45
                    'hoaCoupondId': hoaCouponId,
                },
            })
        }
    }

    /**
     * Retrieve product details for PMC HOA
     */
    public productDetailsPOST(anonymous: boolean, pmcCouponId: string, hoaCouponId: string): Observable<Products> {
        this.check({ anonymous }, 'is boolean', a => typeof a === 'boolean')
        this.check({ pmcCouponId, hoaCouponId }, 'is non-empty string', a => typeof a === 'string' && a.length > 0)

        const couponData: CouponData = {
            hoaCouponId: hoaCouponId,
            pmcCouponId: pmcCouponId,
        }
        return this.http.post<Products>(this.createUrl(anonymous ? 'HOAPass' : 'hoa-gateway', '/organization/products'), couponData)
    }
}

